import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../../utils/types";
import {
  selectUserLoading,
  selectUserRatings,
} from "../../../../../redux/educator/selector";
import { getUserRatingsById } from "../../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  userRatings: selectUserRatings(state),
  userRatingsLoading: selectUserLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getUserRatingsById,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
